/**
 * パスワード入力の整形(2026-09-10 発注者指示)。
 *
 * 入力欄に混ざったスペース(半角・全角)やタブは、打ち間違い・コピーの混入なので取り除く。
 * このシステムのパスワードは英数字で運用しており、スペースを含める運用はない
 * (実際に「いまのパスワードが違います」で入れなくなる事例があったため)。
 */
export function normalizePassword(value: string): string {
  return (value ?? '').replace(/\s/g, '');
}
